import { Editor } from '@tiptap/core';

import { tableHasContent, rowHasContent } from 'containers/Tiptap/lib/table-validation-utils';

import { SCREEN_WIDTH_BREAKPOINTS } from 'core/constants';

import { SidebarEnum } from './types';

export const computeMarginRight = (
  activeSidebar: false | SidebarEnum.Versioning | SidebarEnum.Comments,
  selectedThread: string | null,
  windowWidth: number
): string => {
  const commentsOpen = activeSidebar === SidebarEnum.Comments || !!selectedThread;
  const isSmallScreen = windowWidth <= SCREEN_WIDTH_BREAKPOINTS.SMALL_SCREEN;

  if (commentsOpen) {
    return isSmallScreen ? '300px' : '340px';
  }

  return '0px';
};

/**
 * Cleans up empty table rows and tables from the editor
 * Returns true if any cleanup was performed
 */
export const cleanupEmptyTables = (currentEditor: Editor): boolean => {
  if (!currentEditor?.state) return false;

  const { state } = currentEditor;
  const { tr } = state;
  const positionsToDelete: Array<{ from: number; to: number }> = [];

  state.doc.descendants((node, pos) => {
    if (node.type.name === 'table' && !tableHasContent(node)) {
      positionsToDelete.push({ from: pos, to: pos + node.nodeSize });
      return false; // Don't descend into empty table
    }

    if (node.type.name === 'tableRow' && !rowHasContent(node)) {
      positionsToDelete.push({ from: pos, to: pos + node.nodeSize });
    }
    return true;
  });

  if (positionsToDelete.length > 0) {
    positionsToDelete.sort((a, b) => b.from - a.from);
    positionsToDelete.forEach(({ from, to }) => {
      if (from >= 0 && to <= tr.doc.content.size && from < to) {
        tr.delete(from, to);
      }
    });
    currentEditor.view.dispatch(tr);
    return true;
  }

  return false;
};
